import React, { useCallback, useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { routes } from './routes/routes';
import Router from './routes/Router';
import Theme from './components/Theme/Theme';
import { LocalizationProvider } from './locale/localizationContext';
import { useAppSelector } from './redux/core';
import { isAppInitializedSelector } from './redux/general/general.selectors';
import { loadMaps } from './hooks/useDesktopGoogleApi';
import LoaderFullPage from './components/LoaderFullPage/LoaderFullPage';
import {
  authTokenSelector,
  isEmailConfirmedSelector,
} from './redux/user/user.selectors';
import { ErrorBoundary } from 'react-error-boundary';
import GeneralError from './components/GeneralError/GeneralError';

type AppProps = {};

export const App: React.FC<AppProps> = () => {
  const isAppInitialized = useAppSelector(isAppInitializedSelector);
  const hasToken = useAppSelector(authTokenSelector);
  const isEmailConfirmed = useAppSelector(isEmailConfirmedSelector);

  const isAuthenticated: boolean = isEmailConfirmed && !!hasToken;

  const [isMapInitialized, setIsMapInitialized] = useState(false);

  useEffect(() => {
    loadMaps(() => {
      setIsMapInitialized(true);
    });
  }, []);

  const fallback = useCallback(() => <GeneralError />, []);

  return (
    <Theme>
      <LocalizationProvider>
        {!isAppInitialized || !isMapInitialized ? (
          <LoaderFullPage show={true} />
        ) : (
          <BrowserRouter>
            <ErrorBoundary fallbackRender={fallback}>
              <Router authorized={isAuthenticated} routes={routes} />
            </ErrorBoundary>
          </BrowserRouter>
        )}
      </LocalizationProvider>
      <LoaderFullPage />
    </Theme>
  );
};

export default App;
